/**
 * Ensures session_ended and log_out are only sent once per logout,
 * even when both useLoginMutation.logout and useAuthToken.logout run (e.g. click + Apollo error).
 */
let logoutEventsSentThisSession = false;
let logoutInProgress = false;

export function getLogoutEventsSent(): boolean {
  return logoutEventsSentThisSession;
}

export function setLogoutEventsSent(value: boolean): void {
  logoutEventsSentThisSession = value;
}

export function beginLogout(): boolean {
  if (logoutInProgress) return false;
  logoutInProgress = true;
  return true;
}

export function endLogout(): void {
  logoutInProgress = false;
}

export function resetLogoutTracking(): void {
  logoutEventsSentThisSession = false;
  logoutInProgress = false;
}
